import { store } from "@/store/store";

export const moduleCheck = module => {
  const { company } = store.state.company;
  const configuration = company && company.configuration;

  if (configuration && configuration.disabled_modules) {
    return !configuration.disabled_modules.includes(module);
  }

  return true;
};
